<script lang="ts" setup>
import { useContacts } from '@/domains/about/company/abroad/composables/useContacts'

const { countries } = useContacts()
</script>

<template>
  <section class="contacts">
    <div class="contacts__container">
      <h4
        class="contacts__header"
        v-html="$t('aboutCompany.contact.title')"
      />

      <div class="contacts__grid">
        <article
          v-for="(country, index) in countries"
          :key="index"
          class="contact-card"
        >
          <h5 class="contact-card__title">
            {{ country.title }}
          </h5>

          <a
            class="contact-card__phone"
            :href="`tel:${country.phone.replace(/\s+/g, '')}`"
          >
            {{ country.phone }}
          </a>

          <a
            class="contact-card__email"
            :href="`mailto:${country.email}`"
          >
            {{ country.email }}
          </a>
        </article>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.contacts {
  padding: 4rem 2.4rem;
  background: $gray-100;

  @include atM {
    padding: 8rem 2.4rem;
  }

  &__container {
    max-width: 156rem;
    margin: 0 auto;
  }

  &__header {
    margin-bottom: 4rem;

    color: $darkblue-400;
    font-weight: 500;
    font-size: 2.8rem;
    line-height: 3.6rem;

    @include atM {
      margin-bottom: 6rem;

      font-size: 4.8rem;
      line-height: 5.6rem;
    }

    @include atXL {
      font-size: 5.6rem;
      line-height: 6.8rem;
    }
  }

  &__grid {
    display: grid;

    grid-template-columns: 1fr;
    gap: 2rem;

    @include atS {
      grid-template-columns: repeat(2, 1fr);
    }

    @include atM {
      grid-template-columns: repeat(3, 1fr);
    }

    @include atL {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}

.contact-card {
  padding: 3.2rem;

  background: $white;
  border: 1px solid $gray-300;

  transition:
    border-color .2s ease,
    box-shadow .2s ease;

  &:hover {
    border-color: $gray-500;
    box-shadow: 0 .8rem 2rem rgb(19 37 70 / 6%);
  }

  &__title {
    margin-bottom: 2rem;

    color: $text-400;
    font-weight: 700;
    font-size: 2rem;
    line-height: 2.8rem;
    text-transform: uppercase;
  }

  &__phone,
  &__email {
    display: block;

    font-size: 1.8rem;
    line-height: 3rem;
    text-decoration: none;
  }

  &__phone {
    margin-bottom: .8rem;
    color: $text-400;

    &:hover {
      color: $brand-blue-500;
    }
  }

  &__email {
    color: $color-social;
    word-break: break-word;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>